import { render, staticRenderFns } from "./ExerciseDetailModal.vue?vue&type=template&id=409bfa40&scoped=true"
import script from "./ExerciseDetailModal.vue?vue&type=script&lang=js"
export * from "./ExerciseDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ExerciseDetailModal.vue?vue&type=style&index=0&id=409bfa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bfa40",
  null
  
)

export default component.exports